import PosterGenerator from '../../components/PosterGenerator';
import BaseView from './BaseView';

let view = null;

class PosterGeneratorView extends BaseView {
    constructor(container) {
        super(container);
    }

    init() {

        this.container.querySelectorAll('[data-poster-generator]').forEach((component) => {
            this.components.push(new PosterGenerator(component));
        });
    }

    destroy() {
        super.destroy();
    }
}

export default {
    namespace: 'template-poster-generator',
    beforeEnter: ({ current, next, trigger }) => {
        view = new PosterGeneratorView(next.container);
        view.init();
    },
    afterLeave: ({ current, next, trigger }) => {
        view.destroy();
        view = null;
    },
};
